import { render, staticRenderFns } from "./ZoneDashboard.vue?vue&type=template&id=2712d225"
import script from "./ZoneDashboard.vue?vue&type=script&lang=js"
export * from "./ZoneDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports